import React, { useState, useEffect } from "react";
import { IntlProvider } from "react-intl";
import { Layout } from "./Layout/Layout";
import { translations } from "./translations";
import { parseLang } from "./utils";
import MunicipalityContext from "./MunicipalityContext";

async function getMunicipalities() {
  const response = await fetch(process.env.REACT_APP_GET_MUNICIPALITIES_URL);
  const body = await response.json();

  if (response.status !== 200) {
    throw Error(body.message);
  }

  return body;
}

export const App = props => {
  const [municipalities, setMunicipalities] = useState([]);

  // redirect nimileima.tukes.fi => rekisterit.tukes.fi/nimileimat
  if (props.location.host === "nimileima.tukes.fi") {
    window.location = `${process.env.REACT_APP_URL}/nimileimat`;
  }
  
  useEffect(() => {
    setMunicipalities([]);
    getMunicipalities()
      .then(res => setMunicipalities(res))
      .catch(err => console.log(err));
  }, []);

  const queryLang = parseLang(props.location.search);

  return (
    <IntlProvider locale={queryLang} messages={translations[queryLang]}>
      <MunicipalityContext.Provider value={municipalities}>
        <Layout locale={queryLang} location={props.location}>
          {props.children}
        </Layout>
      </MunicipalityContext.Provider>
    </IntlProvider>
  );
};



// WEBPACK FOOTER //
// ./src/App.js